import React from "react";
import { formatDateShortMonth } from "@utils";
import { Checkbox } from "@components";
import { formatAmount } from "@utils";
import {
  LedgerItemTemplate,
  LedgerCheckboxLabel,
} from "./LedgerItemTemplate.jsx";

export const CreditNoteItem = ({
  creditNote,
  required,
  selected,
  toggleInvoice,
}) => {
  return (
    <LedgerItemTemplate
      key={creditNote.ledgerTransactionId}
      left={
        <LedgerCheckboxLabel>
          <Checkbox
            checked={selected.has(creditNote.ledgerTransactionId)}
            onChange={() => toggleInvoice(creditNote.ledgerTransactionId)}
            readOnly={required}
          />
        </LedgerCheckboxLabel>
      }
      title={creditNote.transactionNumber}
      amount={formatAmount(creditNote.remainingAmount)}
      amountClassName="text-emerald-700"
      dateText={formatDateShortMonth(creditNote.dueDate)}
      dateClassName="text-sm text-zinc-500 whitespace-nowrap"
    />
  );
};
